import "reflect-metadata";
import * as React from "react";
import * as ReactDOM from "react-dom";
import {applyMiddleware, combineReducers, createStore} from "redux";
import {Provider} from "react-redux";
import createHistory from "history/createBrowserHistory";
import {ConnectedRouter, routerMiddleware, routerReducer} from "react-router-redux";
import ReduxThunk from "redux-thunk";
import feedsReducer from "../activityFeeds/reducers";
import userReducer from "../user/reducers";
import styleReducer, {myStylesReducer} from "../style/reducers";
import {myShopsReducer, shopProfileReducer} from "../shop/reducers";
import mySpecialsReducer, {specialReducer} from "../special/reducers";
import RouterContainer from "../dashboard/containers/RouterContainer";
import {Route} from "react-router";
import dataReducer from "../_data/reducers";
import {reducer as reduxFormReducer} from "redux-form";
import searchReducer from "../search/reducers";
import {addDataAction} from "../_data/actions";
import {ResourceType} from "../_helpers/data";
import {plainToClass} from "class-transformer";
import User from "../_data/models/User";
import {addCurrentUserAction} from "../user/actions";
import {conversations, messages} from "../message/reducers";
import DashboardComponent from "../dashboard/components/DashboardComponent";
import {fetchConversations} from "../message/middlewares";

const history = createHistory();
const middleware = routerMiddleware(history);


const store = createStore(
    combineReducers({
        data: dataReducer,
        feeds: feedsReducer,
        user: userReducer,
        style: styleReducer,
        form: reduxFormReducer,
        router: routerReducer,
        myStyles: myStylesReducer,
        myShops: myShopsReducer,
        shopProfile: shopProfileReducer,
        mySpecials: mySpecialsReducer,
        special: specialReducer,
        search: searchReducer,
        conversations: conversations,
        messages: messages
    }),
    applyMiddleware(middleware, ReduxThunk)
);

if (window.Styleteq.currentUser) {
    store.dispatch(addCurrentUserAction({
        id: plainToClass(User, window.Styleteq.currentUser).id
    }));
    store.dispatch(addDataAction({
        resource: ResourceType.user,
        data: window.Styleteq.currentUser
    }));
    store.dispatch(fetchConversations());
}

ReactDOM.render(
    <Provider store={store}>
        <ConnectedRouter history={history}>
            <DashboardComponent>
                <Route render={(props) => {
                    return <RouterContainer {...props}/>;
                }}/>
            </DashboardComponent>
        </ConnectedRouter>
    </Provider>,
    document.getElementById('root')
);




// WEBPACK FOOTER //
// ./app/client/_packs/client.tsx